module.exports = __webpack_public_path__ + "img/blog-7-121-78.6fc7858.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/blog-7-121-78.jpg
// module id = 155
// module chunks = 1